// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2OOuK","upload":"Small_upload__2Hz9H","imageWrap":"Small_imageWrap__1y8KJ","removeBtn":"Small_removeBtn__2v87i"};